<script setup lang="ts">
const platform = useState('platform')

if (!platform.value.settings.organizations_search_page) {
  await navigateTo('/')
}

const queryCoordinates = useRouteQuery('coordinates', null)
const queryValue = useRouteQuery('value', null)
const queryDomains = useRouteQuery('domain', null)
const querySearch = useRouteQuery('q', null)

const search = reactive({
  coordinates: queryCoordinates.value,
  value: queryValue.value,
  domain: queryDomains.value,
  q: querySearch.value,
})

watch(() => search.coordinates, (val) => queryCoordinates.value = val)
watch(() => search.value, (val) => queryValue.value = val)
watch(() => search.domain, (val) => queryDomains.value = val)
watch(() => search.q, (val) => querySearch.value = val)

const organizations = ref([]);
const nextCursor = ref(null);

const {execute, refresh, status} = useApi(`/search/organization`, {
  query: {
    domains: queryDomains,
    coordinates: queryCoordinates,
    q: querySearch,
    cursor: nextCursor,
  },
  key: () => 'organization-search-' + JSON.stringify(search), // TODO: https://github.com/nuxt/nuxt/issues/32437
  watch: false,
  lazy: true,
  immediate: false,
  server: false,
  transform: (res) => {
    organizations.value = organizations.value.concat(res.data);
    nextCursor.value = res.next_cursor;
    return res;
  },
});

onMounted(async () => {
  await execute()
})

watch(() => JSON.stringify(search), async () => {
  nextCursor.value = null;
  organizations.value = []
  await execute();
});

const canLoadMore = computed(() => status.value === 'success' && !!nextCursor.value)

const rootEl = ref(null)
const isVisible = useElementVisibility(rootEl)

useInfiniteScroll(
    document,
    async () => {
      await refresh();
    },
    {
      canLoadMore: () => isVisible.value && canLoadMore.value,
      distance: 700,
    }
);
</script>

<template>
  <div class="w-full min-h-[calc(100vh-var(--ui-header-height))] bg-muted">
    <div class="border-b border-muted relative bg-default">
      <UContainer>
        <SearchForm v-model="search" title="Rechercher<br>une association" searchLabel="Association"/>
      </UContainer>
    </div>
    <UContainer class="pb-20 pt-10">
      <div ref="rootEl">
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <SearchOrganizationCard :organization="organization" v-for="organization in organizations" />
          <SearchOrganizationCard :organization="null" v-for="i in 6" :key="`empty-org-${i}`" v-if="status == 'pending' || status == 'idle'" />
        </div>
      </div>
      <div class="mx-auto w-full max-w-(--container-3xl) px-4 sm:px-6 lg:px-8 py-25 space-y-4 text-center" v-if="status === 'success' && !organizations.length">
        <p class="text-2xl font-bold text-center">Aucune association trouvée</p>
        <p class="text-center">N’hésitez pas à élargir vos critères de recherche</p>
      </div>
    </UContainer>
  </div>
</template>